import { PartImageTolerance } from '@/api/generatedApi';

export interface PartImageToleranceChoice {
  label: string;
  tolerance: PartImageTolerance;
}

export const TOLERANCE_CHOICES: PartImageToleranceChoice[] = [
  { label: '±0.005 in (caliper)', tolerance: { percent: 0, minInches: 0.005 } },
  { label: '±2%, at least ±0.01 in (default)', tolerance: { percent: 2, minInches: 0.01 } },
  { label: '±5%, at least ±0.01 in', tolerance: { percent: 5, minInches: 0.01 } },
  { label: '±1/16 in (ruler)', tolerance: { percent: 0, minInches: 0.0625 } },
  { label: '±10%, at least ±1/16 in (estimate)', tolerance: { percent: 10, minInches: 0.0625 } },
];

export const DEFAULT_TOLERANCE_CHOICE = TOLERANCE_CHOICES[1];

const toleranceInches = (inches: number, { percent, minInches }: PartImageTolerance): number =>
  Math.max(minInches, (inches * percent) / 100);

const formatInches = (inches: number): string => String(Number(inches.toFixed(3)));

export function matchedRange(inches: number, tolerance: PartImageTolerance): string {
  const within = toleranceInches(inches, tolerance);
  return `${formatInches(Math.max(0, inches - within))} – ${formatInches(inches + within)} in`;
}
